import { memo } from "react";
import { twMerge } from "tailwind-merge";

import Spinner from "./Spinner";

interface Props {
  big?: boolean;
  circle?: boolean;
  className?: string;
}

function Loading({ big, circle = true, className }: Props) {
  return (
    <div
      className={twMerge(
        "absolute inset-0 flex h-full w-full items-center justify-center",
        className,
      )}
    >
      {!circle && <Spinner className={twMerge(!!big && "size-16")} />}
      {circle && (
        <svg
          className={twMerge("size-5 animate-spin", !!big && "size-10")}
          fill="currentColor"
          stroke="transparent"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z" />
        </svg>
      )}
    </div>
  );
}

export default memo(Loading);
